import {
  globalHumanReadableRender,
  IAttributeOperator,
  wrapWithProtectionCondition,
  wrapWithProtectionConditionForNegation
} from './crm-entities-base-operators';
import { TranslateService } from '@ngx-translate/core';

///////////////////////////
//   Numbers Operators   //
///////////////////////////
class NumberAttributeOperatorBase implements IAttributeOperator {
  freeMarkerOperator: string;
  name: string;
  displayNameKey: string;
  humanReadableTranslationKey: string;

  renderHumanReadable(translate: TranslateService, left: string, right: any) {
    return globalHumanReadableRender.apply(this, [translate, left, right]);
  }

  renderFreeMarker(left: string, right: any) {
    return `${wrapWithProtectionCondition(left)} && ((${left})?number ${this.freeMarkerOperator} ${right})`;
  }
}

export class NumberOperatorEquals extends NumberAttributeOperatorBase {
  freeMarkerOperator = '==';
  name = 'equalsNumber';
  displayNameKey = 'COMMON.CRM_ENTITY_OPERATORS.EQUALS';
  humanReadableTranslationKey = 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.EQUALS';
}

export class NumberOperatorDifferent extends NumberAttributeOperatorBase {
  freeMarkerOperator = '!=';
  name = 'differentNumber';
  displayNameKey = 'COMMON.CRM_ENTITY_OPERATORS.DIFFERENT';
  humanReadableTranslationKey = 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.DIFFERENT';

  renderFreeMarker(left: string, right: any) {
    return `${wrapWithProtectionConditionForNegation(left)} || ((${left})?number ${this.freeMarkerOperator} ${right})`;
  }
}

export class NumberOperatorLessThan extends NumberAttributeOperatorBase {
  freeMarkerOperator = '<';
  name = 'lessThanNumber';
  displayNameKey = 'COMMON.CRM_ENTITY_OPERATORS.LESS_THAN';
  humanReadableTranslationKey = 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.LESS_THAN';
}

export class NumberOperatorLessThanEqual extends NumberAttributeOperatorBase {
  freeMarkerOperator = '<=';
  name = 'lessOrEqualToNumber';
  displayNameKey = 'COMMON.CRM_ENTITY_OPERATORS.LESS_OR_EQUAL_TO';
  humanReadableTranslationKey = 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.LESS_OR_EQUAL_TO';
}

export class NumberOperatorGreaterThan extends NumberAttributeOperatorBase {
  freeMarkerOperator = '>';
  name = 'greaterThanNumber';
  displayNameKey = 'COMMON.CRM_ENTITY_OPERATORS.GREATER_THAN';
  humanReadableTranslationKey = 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.GREATER_THAN';
}

export class NumberOperatorGreaterThanEqual extends NumberAttributeOperatorBase {
  freeMarkerOperator = '>=';
  name = 'greaterOrEqualThanNumber';
  displayNameKey = 'COMMON.CRM_ENTITY_OPERATORS.GREATER_OR_EQUAL_TO';
  humanReadableTranslationKey = 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.GREATER_OR_EQUAL_TO';
}
